import { appI18n } from '@flowus/common/i18n';
import { CollectionViewType } from '@next-space/fe-api-idl';
import type { IconName } from 'src/common/components/icon';
import { helperLink } from 'src/components/helper-icon';

export const ViewNameMap = {
  [CollectionViewType.TABLE]: appI18n.t('common.table'),
  [CollectionViewType.BOARD]: appI18n.t('common.board'),
  [CollectionViewType.GALLERY]: appI18n.t('common.gallery'),
  [CollectionViewType.LIST]: appI18n.t('common.directory'),
  [CollectionViewType.TIMELINE]: appI18n.t('common.timeline'),
  [CollectionViewType.CALENDAR]: appI18n.t('common.calendar'),
  [CollectionViewType.FORM]: appI18n.t('common.form'),
  [CollectionViewType.SPACE]: '',
};

export const ViewIconMap: Record<CollectionViewType, IconName | null> = {
  [CollectionViewType.TABLE]: 'IcTable',
  [CollectionViewType.BOARD]: 'IcBoard',
  [CollectionViewType.GALLERY]: 'IcGallery',
  [CollectionViewType.LIST]: 'IcList',
  [CollectionViewType.TIMELINE]: 'IcTimeline',
  [CollectionViewType.CALENDAR]: 'IcCalendar',
  [CollectionViewType.FORM]: 'IcForm',
  [CollectionViewType.SPACE]: null,
};

export const TableViewMap = [
  {
    name: appI18n.t('common.table'),
    type: CollectionViewType.TABLE,
    helperLink: helperLink.tableViewLink,
  },
  {
    name: appI18n.t('common.board'),
    type: CollectionViewType.BOARD,
    helperLink: helperLink.boardViewLink,
  },
  {
    name: appI18n.t('common.gallery'),
    type: CollectionViewType.GALLERY,
    helperLink: helperLink.galleryViewLink,
  },
  {
    name: appI18n.t('common.directory'),
    type: CollectionViewType.LIST,
    helperLink: helperLink.listViewLink,
  },
  {
    name: appI18n.t('common.timeline'),
    type: CollectionViewType.TIMELINE,
    helperLink: helperLink.timeViewLink,
  },
  {
    name: appI18n.t('common.calendar'),
    type: CollectionViewType.CALENDAR,
    helperLink: helperLink.calendarViewLink,
  },
  {
    name: appI18n.t('common.form'),
    type: CollectionViewType.FORM,
    helperLink: helperLink.formViewLink,
  },
];
